import { ulid } from 'ulid';
import type {
	CreateCampaignInput,
	UpdateCampaignInput
} from '@/graphql/generated';
import type { CampaignFormSubmitData } from './campaign-form';

export type { CampaignFormSubmitData };

export const buildCreateCampaignInput = (
	formData: CampaignFormSubmitData,
	campaignId: string
): CreateCampaignInput => {
	return {
		campaignId,
		name: formData.name,
		description: formData.description ?? null,
		startDate: formData.startDate,
		endDate: formData.endDate,
		isActive: formData.isActive
	};
};

export const buildUpdateCampaignInput = (
	formData: CampaignFormSubmitData,
	campaignId: string
): UpdateCampaignInput => {
	return {
		campaignId,
		name: formData.name,
		description: formData.description ?? null,
		startDate: formData.startDate,
		endDate: formData.endDate,
		isActive: formData.isActive
	};
};

export const generateIdempotentCampaignId = (): string => {
	return ulid();
};
